import { useContext } from 'react';
import { AuthInfoContext } from '../context/AuthContext';

/**
 * ユーザーが読み取り専用かどうかを判定するカスタムフック
 * @returns {boolean} - 読み取り専用の場合はtrue、それ以外はfalse
 */
export const useReadOnly = (): boolean => {
  const [authInfo] = useContext(AuthInfoContext);
  return authInfo.read_only_flg === true;
};